import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import api from '../../api/api';

// ======== CHECKOUT ==========
export const checkout = createAsyncThunk(
  'cart/checkout',
  async (orderData, { rejectWithValue }) => {
    try {
      const response = await api.post('/orders/checkout/', orderData);
      return response.data;
    } catch (error) {
      return rejectWithValue(error.response?.data || "Ошибка оформления заказа");
    }
  }
);

// ======== PAYMENT METHODS ==========
export const fetchPaymentMethods = createAsyncThunk(
  "cart/fetchPaymentMethods",
  async (_, { rejectWithValue }) => {
    try {
      const res = await api.get("/orders/payment-methods/");
      return res.data;
    } catch (e) {
      return rejectWithValue("Не удалось загрузить способы оплаты");
    }
  }
);

// ======== DELIVERY METHODS ==========
export const fetchDeliveryMethods = createAsyncThunk(
  "cart/fetchDeliveryMethods",
  async (_, { rejectWithValue }) => {
    try {
      const res = await api.get("/orders/delivery-methods/");
      return res.data;
    } catch (e) {
      return rejectWithValue("Не удалось загрузить способы доставки");
    }
  }
);

const initialState = {
  items: [],

  status: 'idle',
  orderError: null,

  paymentMethods: [],
  deliveryMethods: [],

  orderSuccess: false,
  orderNumber: null   // <<< ДОДАНО !!!
};

const cartSlice = createSlice({
  name: 'cart',
  initialState,
  reducers: {
    addToCart: (state, action) => {
      const existing = state.items.find((i) => i.id === action.payload.id);
      if (existing) existing.quantity++;
      else state.items.push({ ...action.payload, quantity: 1 });
    },

    removeFromCart: (state, action) => {
      state.items = state.items.filter((i) => i.id !== action.payload.id);
    },

    updateQuantity: (state, action) => {
      const item = state.items.find((i) => i.id === action.payload.id);
      if (item) item.quantity = action.payload.quantity;
    },

    clearCart: (state) => {
      state.items = [];
    },

    resetOrderSuccess: (state) => {
      state.orderSuccess = false;
      state.orderError = null;
    }
  },

  extraReducers: (builder) => {
    builder
      // ==== CHECKOUT ====
      .addCase(checkout.pending, (state) => {
        state.status = 'loading';
        state.orderError = null;
      })
      .addCase(checkout.fulfilled, (state, action) => {
        state.status = 'succeeded';
        state.orderNumber = action.payload.id;
        state.orderSuccess = true;
        state.items = []; 
      })
      .addCase(checkout.rejected, (state, action) => {
        state.status = 'failed';
        state.orderError =
          action.payload?.detail ||
          action.payload?.error ||
          action.payload ||
          "Ошибка оформления заказа";
      })

      // ==== PAYMENT METHODS ====
      .addCase(fetchPaymentMethods.fulfilled, (state, action) => {
        state.paymentMethods = action.payload.results || [];
      })

      // ==== DELIVERY METHODS ====
      .addCase(fetchDeliveryMethods.fulfilled, (state, action) => {
        state.deliveryMethods = action.payload.results || [];
      });
  },
});

export const { 
  addToCart, 
  removeFromCart, 
  updateQuantity, 
  clearCart,
  resetOrderSuccess
} = cartSlice.actions;

export default cartSlice.reducer;
